<mat-expansion-panel
    class="mat-elevation-z0"
    [expanded]="pinnedPanels[silentDataKey]"
    #classicContactsExpansionPanel
>
    <mat-expansion-panel-header>
        <mat-panel-title>
            <mat-icon class="cb-grey cb-margin-right">contacts</mat-icon>
            <b>Classic Contacts</b>
        </mat-panel-title>
        <mat-panel-description class="end-center flex-row">
            @if (classicContactsExpansionPanel.expanded || silentData[silentDataKey]) {
                <button mat-icon-button (click)="togglePanelPinned($event, silentDataKey)">
                    <mat-icon svgIcon="pin" [ngClass]="{ 'cb-accent': silentData[silentDataKey] }">
                    </mat-icon>
                </button>
            }
        </mat-panel-description>
    </mat-expansion-panel-header>
    <div class="flex-col">
        <div class="flex-wrap flex">
            @if (businessEntityField.isVisible) {
                <cb-display-value-new class="flex-50" label="Business Entity">
                    {{ lotMappedItem?.businessEntity.label | cbDasher }}
                </cb-display-value-new>
            }
            @if (hlCoordinatorField.isVisible) {
                <cb-display-value-new class="flex-50" label="HL Coordinator">
                    {{ lotMappedItem?.contacts.houseAndLandCoordinator?.label | cbDasher }}
                </cb-display-value-new>
            }
            @if (buildingConsultantField.isVisible) {
                <cb-display-value-new class="flex-50" label="Building Consultant">
                    {{ lotMappedItem?.contacts.buildingConsultant?.label | cbDasher }}
                </cb-display-value-new>
            }
            @if (buildingCoordinatorField.isVisible) {
                <cb-display-value-new class="flex-50" label="Building Coordinator">
                    {{ lotMappedItem?.contacts.buildingCoordinator?.label | cbDasher }}
                </cb-display-value-new>
            }
            @if (designerField.isVisible) {
                <cb-display-value-new class="flex-50" label="Designer">
                    {{ lotMappedItem?.contacts.designer?.label | cbDasher }}
                </cb-display-value-new>
            }
            @if (quantitySurveyorField.isVisible) {
                <cb-display-value-new class="flex-50" label="QS">
                    {{ lotMappedItem?.contacts.quantitySurveyor?.label | cbDasher }}
                </cb-display-value-new>
            }
            @if (foundationManagerField.isVisible) {
                <cb-display-value-new class="flex-50" label="Foundation Manager">
                    {{ lotMappedItem?.contacts.foundationManager?.label | cbDasher }}
                </cb-display-value-new>
            }
            @if (framingManagerField.isVisible) {
                <cb-display-value-new class="flex-50" label="Framing Manager">
                    {{ lotMappedItem?.contacts.framingManager?.label | cbDasher }}
                </cb-display-value-new>
            }
            @if (qualityAssuranceManagerField.isVisible) {
                <cb-display-value-new class="flex-50" label="QA Manager">
                    {{ lotMappedItem?.contacts.qualityAssuranceManager?.label | cbDasher }}
                </cb-display-value-new>
            }
        </div>
    </div>
</mat-expansion-panel>
